import { connect } from 'react-redux';
import { selectors, constants, actions } from '@amplement/backend-connector';
import { getCurrentUserIdSelector } from 'selectors/user';

import Component from './index';

const mapStateToProps = (state, { id }) => {
    const room = selectors.rooms.getRoomByIdSelector(state, id);
    const members = selectors.rooms.getRoomMembersByRoomIdSelector(state, id);
    const caller = selectors.rooms.getRoomInitiatorByRoomIdSelector(state, id);
    const _currentUser = getCurrentUserIdSelector(state);
    const name = selectors.rooms.getDisplayRoomNameSelector(state, id);
    const { _feed } = room || {};

    return ({
        isInitiator: caller?._user === _currentUser,
        members,
        name,
        isLive: members?.filter(x => x.status === constants.rooms.USER_IN_ROOM_STATUS.JOINED)?.length > 0,
        _feed
    });
};

const mapDispatchToProps = dispatch => ({
    onLeave: (_room) => dispatch(actions.rooms.requestRoomQuit(_room)),
    onDelete: (_room) => dispatch(actions.rooms.requestDeleteRoom(_room))
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
